import { FC, SVGProps } from 'react';

export const ProductsIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2.75" y="2.75" width="18.5" height="18.5" rx="1.35526" stroke="#141414" strokeWidth="1.5" />
    <path d="M6.21045 12.5264H11.9999" stroke="#141414" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.21045 16.7368H15.1578" stroke="#141414" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
